/**
 * ProviderSetupProgress — App 行内的五步接入进度指示（设计稿 PayerMax A1）。
 *
 * 已完成步骤为 `--pos-soft` 勾、当前步骤为 accent 圆加 ring、其后为灰色序号；步骤间以 8px 连线相接，
 * 已走过的连线取 `--pos`。步骤判据见 `payment-provider-config-view.ts` 的 `setupCurrentStep`。
 */

import { Icons } from '~/lib/icons';
import { SETUP_STEPS } from './payment-provider-config-view';

const CIRCLE = 18;
const STEP_MARKS = ['①', '②', '③', '④', '⑤'];

export function ProviderSetupProgress({
  current,
  doneLabel,
}: {
  /** 当前停在第几步（1–5）；null = 全部完成 */
  current: number | null;
  doneLabel: string;
}) {
  const label =
    current === null
      ? doneLabel
      : `停在 ${STEP_MARKS[current - 1]} ${SETUP_STEPS[current - 1]?.title ?? ''}`;
  return (
    <div
      className="hstack"
      style={{ gap: 3 }}
      aria-label={
        current === null
          ? '接入进度：5 步全部完成'
          : `接入进度：停在第 ${current} 步${SETUP_STEPS[current - 1]?.title ?? ''}`
      }
    >
      {SETUP_STEPS.map((step, index) => {
        const n = index + 1;
        const done = current === null || n < current;
        const isCurrent = n === current;
        return (
          <span key={step.title} className="hstack" style={{ gap: 3 }}>
            {index > 0 && (
              <span
                style={{
                  width: 8,
                  height: 1,
                  background: done ? 'var(--pos)' : 'var(--border-strong)',
                }}
              />
            )}
            <span
              className={done ? undefined : 'mono'}
              title={step.title}
              style={{
                width: CIRCLE,
                height: CIRCLE,
                borderRadius: 999,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 10,
                fontWeight: 600,
                ...(done
                  ? { background: 'var(--pos-soft)', color: 'var(--pos)' }
                  : isCurrent
                    ? {
                        background: 'var(--accent-soft)',
                        color: 'var(--accent-fg)',
                        boxShadow: '0 0 0 2px var(--ring)',
                      }
                    : { background: 'var(--bg-muted)', color: 'var(--fg-faint)' }),
              }}
            >
              {done ? <Icons.IconCheck size={10} /> : n}
            </span>
          </span>
        );
      })}
      <span style={{ fontSize: 11, color: 'var(--fg-muted)', marginLeft: 6 }}>{label}</span>
    </div>
  );
}
